module.exports = __webpack_public_path__ + "static/media/logotipo_evolutts.97216680.png";